import { render, staticRenderFns } from "./gloriousedit.vue?vue&type=template&id=40a0a6a4&scoped=true&"
import script from "./gloriousedit.vue?vue&type=script&lang=js&"
export * from "./gloriousedit.vue?vue&type=script&lang=js&"
import style0 from "./gloriousedit.vue?vue&type=style&index=0&id=40a0a6a4&scoped=scoped&lang=scss&"
import style1 from "./gloriousedit.vue?vue&type=style&index=1&id=40a0a6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a0a6a4",
  null
  
)

export default component.exports